import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import Pagination from 'vue-pagination-2';
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker);

Vue.component('pagination', Pagination);

Vue.filter('formatDate', function (value) {
    if (value) {
        return moment(String(value)).format('DD.MM.YYYY');
    }

    return 'Ukjent'
});

Vue.filter('formatStatus', function (value) {
    switch (value) {
        case 'valid':
            return 'Gjeldende'
        case 'future':
            return 'Kommende'
        case 'old':
            return 'Utgått'
        default:
        return 'Ugyldig'
    }
});

Vue.filter('getStatus', function (status) {
 
    if (status === 'valid') {
        return 'Gjeldende'
    }
    else if (status === 'future') {
        return 'Kommende'
    }
    else if (status === 'old') {
        return 'Utgått'
    }

    return 'Ugyldig'
});

Vue.filter('highlight', function (words, query) {
    var iQuery = new RegExp(query, "ig");
    return words.toString().replace(iQuery, function (matchedTxt, a, b) {
        return ('<span class=\'highlight\'>' + matchedTxt + '</span>');
    });
});

const rangeShortcuts =
    [
        { key: 'thisWeek', label: 'Denne uka', value: 'isoWeek' },
        { key: 'lastWeek', label: 'Forrige uke', value: '-isoWeek' },
        //{ key: 'last7Days', label: 'Last 7 days', value: 7 },
        //{ key: 'last30Days', label: 'Last 30 days', value: 30 },
        { key: 'thisMonth', label: 'Denne måneden', value: 'month' },
        { key: 'lastMonth', label: 'Forrige måned', value: '-month' },
        { key: 'thisYear', label: 'I år', value: 'year' },
        { key: 'lastYear', label: 'I fjor', value: '-year' }
    ];

Vue.use(Loading);

var app = new Vue({
    el: '#vueAppRundskrivList',

    data: {
        customShortcuts: rangeShortcuts,
        page: 1,
        paginationOptions: {
            chunksNavigation: 'fixed',
            theme: 'bootstrap4',
            texts: {
                count: `Viser {from} til {to} av {count} poster | {count} poster | En post`
            }
        },
        searchString: '',
        rundskrivs: [],
        filteredRundskrivs: [],
        pageRundskrivs: [],
        validRange: null,
        publishedRange: null,
        status: ['valid', 'future'],
        regulations: [],
        arts: [],
        filterApplied: false,
        filterList: null
    },

    watch: {
        rundskrivs: function (val) {
            if (val !== null) {
                //this.getFilters();
                this.tryLoadFilters();
            }
            this.applyFilters();
        },

        filterList: function (val) {
            //console.log(val);
        },

        searchString: function (val) {
            this.applyFilters();
        },

        filteredRundskrivs: function (val) {
            var self = this;
            self.page = 1;
            self.pageRundskrivs = val.slice(0, 10);
            window.scrollTo(0, 0);
            
        },

        page: function (val) {
            var self = this;
            var startEl = (val - 1) * 10;
            self.pageRundskrivs = self.filteredRundskrivs.slice(startEl, startEl + 10);
            window.scrollTo(0, 0);
        },

        validRange: function () {
            this.applyFilters();
        },

        publishedRange: function () {
            this.applyFilters();
        },

        status: function () {
            this.applyFilters();
        },

        regulations: function () {
            this.applyFilters();
        },

        arts: function (val) {
            this.applyFilters();
        },
    },

    methods: {
        getList: function () {
            let loader = this.$loading.show({
                loader: 'spinner',
                color: '#007bff'
            });
            axios.get('/umbraco/Surface/Rundskriv/GetRundskrivs/')
                .then((response) => {
                    this.rundskrivs = response.data;
                    loader.hide();
                })
                .catch(function (error) {
                    loader.hide();
                    console.log(error);
                });
        },

        getFilters: function () {
            let loader = this.$loading.show({
                loader: 'spinner',
                color: '#007bff'
            });
            axios.get('/umbraco/Surface/Rundskriv/GetFishTypesFilter/')
                .then((response) => {
                    this.filterList = response.data;
                    loader.hide();
                })
                .catch(function (error) {
                    loader.hide();
                    console.log(error);
                });
        },

        pageChange: function (pageNumber) {
            var self = this;
            self.page = pageNumber;
        },

        removeStatusFilter: function (value) {
            var self = this;
            var index = self.status.indexOf(value);
            if (index !== -1) {
                self.status.splice(index, 1);
            }
        },

        applyFilters: function () {
            var self = this;
            self.filterApplied = false;
            var searchString = self.searchString;
            var tempArray = self.rundskrivs;

            if (searchString !== '') {
                tempArray = [];
                self.rundskrivs.forEach(function (element) {
                    var title = element.title.toLowerCase();
                    var number = element.number.toLowerCase();
                    var description = element.description.toLowerCase();
                    if (title.includes(searchString.toLowerCase()) || number.includes(searchString.toLowerCase()) || description.includes(searchString.toLowerCase())) {
                        tempArray.push(element);
                    }
                });
                self.filterApplied = true;
            }

            if (self.status.length > 0) {
                tempArray = tempArray.filter(el => self.status.includes(el.status));
                self.filterApplied = true;
            }
            if (self.validRange !== null && self.validRange.start !== null && self.validRange.end !== null) {
                tempArray = tempArray.filter(el => moment(el.validTo) >= moment(self.validRange.start) && moment(el.validFrom) <= moment(self.validRange.end));
                self.filterApplied = true;
            }

            if (self.publishedRange !== null && self.publishedRange.start !== null && self.publishedRange.end !== null) {
                tempArray = tempArray.filter(el => moment(el.createDate) >= moment(self.publishedRange.start) && moment(el.createDate) <= moment(self.publishedRange.end));
                self.filterApplied = true;
            }
            if (self.regulations.length > 0) {
                tempArray = tempArray.filter(el => self.regulations.some((val) => el.regulations.indexOf(val) !== -1));
                self.filterApplied = true;
            }
            if (self.arts.length > 0) {
                tempArray = tempArray.filter(el => self.arts.some((art) => el.arts.indexOf(art) !== -1));
                self.filterApplied = true;
            }

            self.filteredRundskrivs = tempArray;

            self.saveFilters();
        },

        clearFilters: function () {
            this.searchString = '';
            this.validRange = null;
            this.publishedRange = null;
            this.status = [];
            this.regulations = [];
            this.arts = [];
            this.filterApplied = false;
        },

        saveFilters: function () {
            try {
                var self = this;
                var filters = {
                    searchString: self.searchString,
                    status: self.status,
                    validRange: self.validRange,
                    publishedRange: self.publishedRange,
                    regulations: self.regulations,
                    arts: self.arts
                }

                sessionStorage.setItem('_rflRunskrivFilters', JSON.stringify(filters));
            } catch (e) {
                this.clearFilters();
                console.log('error saving filters');
            }
        },

        tryLoadFilters: function () {
            var self = this;
            try {
                var filters = sessionStorage.getItem('_rflRunskrivFilters');
                filters = $.parseJSON(filters);
                self.getFilters();
                if (filters && filters !== null) {
                    self.searchString = filters.searchString;
                    self.status = filters.status;
                    self.validRange = filters.validRange;
                    self.publishedRange = filters.publishedRange;
                    self.regulations = filters.regulations;
                    self.arts = filters.arts;
                }

            } catch (e) {
                self.clearFilters();
                self.getFilters();
                console.log('error reading filters');
            }
        }
    },

    mounted() {
        this.getList();
    }
});


// WEBPACK FOOTER //
// ./Scripts/app/rundskrivList/index.js